import { render, staticRenderFns } from "./wave.vue?vue&type=template&id=0d3e2e94&scoped=true&"
import script from "./wave.vue?vue&type=script&lang=js&"
export * from "./wave.vue?vue&type=script&lang=js&"
import style0 from "./wave.vue?vue&type=style&index=0&id=0d3e2e94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e2e94",
  null
  
)

export default component.exports